/* global fetch */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from '../ui/Modal'
import FormUtils from '../../lib/FormUtils'
import t from 'tcomb-form'

export default class ContactSupport extends Component {
  static propTypes = {
    onClose: PropTypes.func
  }

  constructor () {
    super()

    const {schema, options} = FormUtils.getForm({
      name: {
        type: 'string',
        required: true
      },
      email: {
        type: 'string',
        attrs: {type: 'email'},
        required: true
      },
      description: {
        type: 'string',
        label: 'Message',
        attrs: {type: 'textarea'},
        required: true
      }
    })

    this.state = {schema, options, value: {}}
  }

  onSubmit (e) {
    e.preventDefault()
    const {value} = this.state
    console.log(value)

    fetch('https://fridgecms.zendesk.com/requests/embedded/create', {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        set_tags: 'web_widget',
        via_id: 48,
        locale_id: '1',
        submitted_from: window.location.href,
        name: value.name,
        email: value.email,
        description: value.description
      })
    }).then((res) => {
      this.onClose()
    })
  }

  onChange (value) {
    this.setState({value})
  }

  onClose = e => {
    e && e.preventDefault()
    this.props.onClose && this.props.onClose()
  }

  render () {
    const {schema, options, value} = this.state

    return (
      <Modal showing={this.props.showing} style={{maxWidth: 500}}>
        <form onSubmit={this.onSubmit.bind(this)}>
          <div className='modal-title'>
            <h1>Contact Support</h1>
          </div>
          <div className='modal-block'>
            <t.form.Form type={schema} options={options} value={value} onChange={this.onChange.bind(this)} />
          </div>
          <div className='modal-links text-right'>
            <a role='button' onClick={this.onClose}>Cancel</a>
            <button type='submit'>Send</button>
          </div>
        </form>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/help/ContactSupport.js